import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAdminAuth } from "@/admin/AdminAuthContext";

export default function AdminLoginPage() {
  const { admin, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.ok) navigate("/admin");
    else setError(result.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-main)] px-4">
      <form
        onSubmit={handleSubmit}
        data-testid="admin-login-form"
        className="w-full max-w-sm border border-[var(--border-default)] bg-[var(--bg-secondary)] p-8"
      >
        <div className="flex items-center gap-2 mb-6">
          <LogIn size={20} className="text-[var(--brand-primary)]" />
          <h1 className="font-display text-2xl text-white">Admin Login</h1>
        </div>
        {error && (
          <p data-testid="admin-login-error" className="text-red-400 text-sm mb-4 font-mono">
            {error}
          </p>
        )}
        <label className="block mb-4">
          <span className="text-xs font-mono uppercase tracking-widest text-white/60">Email</span>
          <input
            data-testid="login-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full mt-2 bg-[var(--bg-main)] border border-[var(--border-default)] px-3 py-2 text-white focus:border-[var(--brand-primary)] outline-none"
          />
        </label>
        <label className="block mb-6">
          <span className="text-xs font-mono uppercase tracking-widest text-white/60">Password</span>
          <input
            data-testid="login-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full mt-2 bg-[var(--bg-main)] border border-[var(--border-default)] px-3 py-2 text-white focus:border-[var(--brand-primary)] outline-none"
          />
        </label>
        <button
          data-testid="login-submit-button"
          type="submit"
          disabled={loading}
          className="btn-primary w-full justify-center disabled:opacity-50"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
